export default __webpack_public_path__ + "static/media/logo.55d0bfb5.png";